import "./Search.scss"
import React, { useRef, useEffect, useState } from 'react';
import ListGroup from 'react-bootstrap/ListGroup';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import Card from 'react-bootstrap/Card';
import {Buffer} from 'buffer';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { Link } from "react-router-dom";
import Container from 'react-bootstrap/Container';
import useWindowSize from '../../components/windowSize/useWindowSize'
import Map, {Marker,Popup,Source, Layer,
    NavigationControl,
    FullscreenControl,
    ScaleControl,
    GeolocateControl} from 'react-map-gl';
import 'mapbox-gl/dist/mapbox-gl.css';

import axios from "axios";

const MAPBOX_TOKEN ='pk.eyJ1Ijoic3R1ZGlncmFkIiwiYSI6ImNsZ25vN3JsazBoazUzbG9ldGlyYnZ0eGMifQ.dJHZGOO-SlBXr70pSXZ3iw';
const SERVER = `https://volunteer-server.onrender.com`
//const SERVER = `http://localhost:8800`

const Search = () => {
      const [popupInfo, setPopupInfo] = useState(null);
      const [data, setData] = useState([]);
      const [dataSearch, setDataS] = useState([]);
      const [inp, setInp] = useState("");
      const [country, setCountry] = useState({center:[1,1]});
      const [newMarkers,setMarkes] = useState([]);
      const [mimeType,setMimeType] = useState("")
      const [image,setImage] = useState("")
      const [filtertData, setFilter] = useState(["volunteer","veterinary","shop","inspection"]);
      const [result,setResult] = useState([])
      const mapRef = useRef();
      const size = useWindowSize();   
      const setPoint = (e) =>{
        setMarkes([{long :e.lngLat.lng,lat : e.lngLat.lat}])
      };

      const parseData = async()=>{
        const result = await axios(`${SERVER}/api/organizations`);
        setData(result.data); 
     
      
      }

     
    
      const handleCheckboxChange = (e,index) => {
        const newCheckboxValues = [...filtertData];
        if(newCheckboxValues[index]){
         
        newCheckboxValues[index] = "";
        setFilter(newCheckboxValues);
        }else{
          newCheckboxValues[index] = e.target.value;
          setFilter(newCheckboxValues);
        }
        
      };


      useEffect(() => {
        parseData()
      }, []);

      useEffect(() => {
        let filtered = data.filter(el => filtertData.includes(el.org_type));
        setResult(filtered)
      }, [data,filtertData]);
      
    return <>
        <Container style={size.width >1400 ? {height: '80vh',maxWidth: '90%'} : {height: '80vh',marginBottom:'20%',maxWidth: '90%'}}>
        <Row>
        <Col xs={size.width >1400 ? 10 : 9} style={{height: '80vh',marginLeft:'0%'}}>
    
        <Map
            ref={mapRef}
            initialViewState={{
            longitude:10,
            latitude:50,
            zoom: 3.5
            }}
            style={{height: '100%',marginTop:'2%',  boxShadow: '1px 2px 9px #F4AAB9'}}
            mapStyle="mapbox://styles/mapbox/streets-v9"
            mapboxAccessToken= {MAPBOX_TOKEN}
            onDblClick={setPoint}
        >;
        
         {newMarkers ? newMarkers.map((elem)=>(
          <Marker 
                longitude={elem.long} 
                latitude={elem.lat} 
                anchor="bottom"  
                style={{cursor:'pointer'}}
                >
        </Marker>
          )) : null}

        {/* <Marker 
                longitude={-100} 
                latitude={40} 
                anchor="bottom"  
                style={{cursor:'pointer'}}
                onClick={e => {
                        e.originalEvent.stopPropagation();
                        setPopupInfo({longitude:-100,latitude:40});
                        }}>
                <img src={ProfilePicture}  width={45} height={45} />
        </Marker> */}
                

              {result.map((el)=>(
                 
                        <Marker 
                                longitude={el.longitude} 
                                latitude={el.latitude} 
                                anchor="bottom"  
                                style={{cursor:'pointer'}}
                                onClick={e => {
                                        e.originalEvent.stopPropagation();
                                        setPopupInfo(el);
                                        }}>
                                <img src={`data:${el.data.type};base64,${new Buffer(el.data).toString('base64')}`}  width={45} height={45} style={{borderRadius:'20%'}}/>
                        </Marker>

              ))}
              
        <Container fluid="md">
        <Row>
        <Col xs={6} md={4}>
        <InputGroup className="mb-3" sty>
     <Form.Control
       placeholder="Пошук"
       aria-label=""
      
       aria-describedby="basic-addon1"
       onChange={async(event)=>{
         setInp(event.target.value)
         const res = await axios.get(`https://api.mapbox.com/geocoding/v5/mapbox.places/${inp}.json?access_token=pk.eyJ1Ijoic3R1ZGlncmFkIiwiYSI6ImNsZ25vN3JsazBoazUzbG9ldGlyYnZ0eGMifQ.dJHZGOO-SlBXr70pSXZ3iw`)
             console.log(res.data.features)
             setDataS(res.data.features)
       }}
       value={inp}
     />
   </InputGroup>
        </Col>
      </Row>
      <ListGroup>
    {inp && dataSearch.map((elem)=>(
        <Row>
          <Col xs={6} md={4}>
          <ListGroup.Item
          onClick={()=>{
            setCountry(elem)
            setInp("")
            mapRef.current.flyTo({
                center: [elem.center[0], elem.center[1]], 
                duration: 2000,
                zoom: 10
            });
          }}
          style={{cursor:'pointer'}}
          >
            {elem.place_name}
            </ListGroup.Item>
            </Col>  
        
        </Row>
    ))}
    </ListGroup>
    </Container>



    <GeolocateControl position="top-right" />
    <FullscreenControl position="top-right" />
    <NavigationControl position="top-right" />
    <ScaleControl position="top-right"/>
  
  
    {popupInfo && (
          <Popup
            anchor="top"
            longitude={Number(popupInfo.longitude)}
            latitude={Number(popupInfo.latitude)}
            onClose={() => setPopupInfo(null)}
           
            
          >
             <Link to={`/organization/${popupInfo.id_organization}`} style={{ textDecoration: "none" }}>
            <div  style={{borderRadius: '10%',color:'black'}}>
            <div style={{textAlign:'center'}}>
            {popupInfo.title}
              </div>
              <div >
              {popupInfo.org_type=='volunteer' ? "Волонтерська організація":null}
              {popupInfo.org_type=='veterinary' ? "Ветеринарна клініка":null}
              {popupInfo.org_type=='shop' ? "Зоомагазин":null}
              {popupInfo.org_type=='inspection' ? "Відділи прикордонного інспекційного контролю":null}
              </div>
              <p>
              Адреса : {popupInfo.location}
              </p>

            </div>
            <img width="100%" src={`data:${popupInfo.data.type};base64,${new Buffer(popupInfo.data).toString('base64')}`} />
            </Link>
          </Popup>
        )}


  </Map>
  </Col>

  <Col style={{marginTop:'5%'}}>
  <Card >
  <Card.Title style={{margin:'auto'}}>Фільтр</Card.Title>
      <Card.Body>
            <Form>
          
              <div key={`default-checkbox`} className="mb-3">
                <Form.Check 
                checked={filtertData[0] == "volunteer"}
                  type={`checkbox`}
                  id={`default-checkbox`}
                  label={`Волонтерські організації`}
                  value={'volunteer'}
                  onChange={(e) => handleCheckboxChange(e,0)}
                />

                <Form.Check
                  checked={filtertData[1] == "veterinary"}
                    type={`checkbox`}
                  id={`default-checkbox2`}
                  label={`Ветеринарні клініки`}
                  value={'veterinary'}
                  onChange={(e) => handleCheckboxChange(e,1)}
                />
                 <Form.Check
                  checked={filtertData[2] == "shop"}
                  type={`checkbox`}
                id={`default-checkbox3`}
                label={`Зоомагазини`}
                value={'shop'}
                onChange={(e) => handleCheckboxChange(e,2)}
                
                           />
                            <Form.Check
                  checked={filtertData[3] == "inspection"}
                  type={`checkbox`}
                id={`default-checkbox3`}
                label={`Відділи прикордонного інспекційного контролю`}
                value={'inspection'}
                onChange={(e) => handleCheckboxChange(e,3)}
                />
              </div>
      
           </Form>
      </Card.Body>
    </Card>
  
  </Col>
  </Row>
  
  </Container>
    </>
    }

export default Search